// extracted by mini-css-extract-plugin
export default {"welcome-page":"WelcomePage_welcome-page__V+Dw3","header":"WelcomePage_header__RInYE","ship":"WelcomePage_ship__EJ6hf","play":"WelcomePage_play__548qX"};